import { Controller } from "@hotwired/stimulus"

// Closes the tab it is on, for a page that exists only to end a round trip
// through another site.
//
// A browser only honours window.close() for a tab a script opened, which the
// one that sent the customer here did. Anyone arriving another way would click
// a button that silently does nothing, so the failure is shown rather than
// swallowed: the tab is still there and only the person can close it.
export default class extends Controller {
  static targets = ["button", "fallback"]

  close() {
    window.close()

    // Still here a moment later means the browser refused.
    setTimeout(() => this.#showFallback(), 250)
  }

  #showFallback() {
    if (this.hasFallbackTarget) this.fallbackTarget.hidden = false
    if (this.hasButtonTarget) this.buttonTarget.disabled = true
  }
}
